import script from "./ProfileSettings.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileSettings.vue?vue&type=script&lang=ts&setup=true"

import "./ProfileSettings.vue?vue&type=style&index=0&id=6fbf16de&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fbf16de"]])

export default __exports__